import React from 'react';

import * as S from './styles';

export const Signature: React.FC = () => {
  return (
    <S.Container>
      <S.Logo />® is a platform at GS Tecnologia e Inovação® company
    </S.Container>
  );
};
